import React from 'react';
export default function ZoomWrapper({ children }) {
const zoom= 0.8;
  return (
    <>
      

      <div
        style={{
          transform: `scale(${zoom})`,
          transformOrigin: "top left",
          width: `${100 / zoom}%`,
        }}
      >
        {children}
      </div>
    </>
  );
}
